import React, { useEffect, useState } from 'react';
import { isValidEmail, normalizeWhitespace } from '../../utils/validation';
import { StepContainer, NavigationButtons, InfoBox, FormField } from '../index';
import { useWizard } from '../../wizard';

interface ErrorState {
  name?: string;
  email?: string;
}

const DriverConsentGuardianContactStep: React.FC = () => {
  const { selfServiceData, updateSelfServiceData, goNext, goBack } = useWizard();
  const [errors, setErrors] = useState<ErrorState>({});

  const notifySecondGuardian = selfServiceData.dlNotifySecondGuardian === true;
  const nameValue = selfServiceData.dlGuardian2Name ?? '';
  const emailValue = selfServiceData.dlGuardian2Email ?? '';

  useEffect(() => {
    if (!notifySecondGuardian) {
      goNext();
    }
  }, [notifySecondGuardian, goNext]);

  const handleFieldChange = (field: 'dlGuardian2Name' | 'dlGuardian2Email', value: string) => {
    updateSelfServiceData(field, value);
    setErrors(prev => ({ ...prev, [field === 'dlGuardian2Name' ? 'name' : 'email']: undefined }));
  };

  const validate = (): ErrorState => {
    const next: ErrorState = {};
    const trimmedName = normalizeWhitespace(nameValue);
    const trimmedEmail = normalizeWhitespace(emailValue);

    if (!trimmedName) {
      next.name = 'Angiv navn på forælder/værge 2.';
    }

    if (!trimmedEmail) {
      next.email = 'Angiv e-mail til forælder/værge 2.';
    } else if (!isValidEmail(trimmedEmail)) {
      next.email = 'Indtast en gyldig e-mailadresse.';
    }

    return next;
  };

  const handleNext = () => {
    const validation = validate();
    setErrors(validation);
    if (Object.keys(validation).length > 0) {
      return;
    }

    goNext();
  };

  if (!notifySecondGuardian) {
    return null;
  }

  return (
    <StepContainer title="Oplysninger til forælder/værge 2">
      <InfoBox type="info">
        <p>Vi bruger oplysningerne til at sende mock-mail/Digital Post til forælder/værge 2, så underskriften kan simuleres.</p>
      </InfoBox>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <FormField
          name="dlGuardian2Name"
          placeholder="Navn"
          value={nameValue}
          onChange={(e) => handleFieldChange('dlGuardian2Name', e.target.value)}
          error={errors.name}
          required
          autoComplete="name"
        />
        <FormField
          type="email"
          name="dlGuardian2Email"
          placeholder="E-mail"
          value={emailValue}
          onChange={(e) => handleFieldChange('dlGuardian2Email', e.target.value)}
          error={errors.email}
          required
          autoComplete="email"
        />
      </div>

      <NavigationButtons onBack={goBack} onNext={handleNext} />
    </StepContainer>
  );
};

export default DriverConsentGuardianContactStep;

